import { Box, Chip, Typography } from '@mui/material'
import { tabularNums } from '../../theme'
import { formatAssignmentAge, type AssignmentAge } from '../../utils/contactAssignment'

/**
 * MWA-354 — how long an assigned contact has waited for outreach, under its
 * "Assigned" date. Shared by the table row, the tablet expander and the phone
 * card so the three renderings of one contact cannot word it differently.
 * Overdue carries the word as well as the colour.
 */
export default function AssignmentAgeNote({ age }: { age: AssignmentAge }) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 0.75, mt: 0.25 }}>
      <Typography variant="caption" color="text.secondary" sx={tabularNums}>
        {formatAssignmentAge(age.days)}
      </Typography>
      {age.overdue && (
        <Chip label="Overdue" size="small" color="warning" variant="outlined" sx={{ height: 20 }} />
      )}
    </Box>
  )
}
